import { BillingTerm, PaymentOption } from '../../modules/privateOffer/types'

export const getPaymentOptionDisplayValue = (
  billingTerm: BillingTerm,
  paymentOption: PaymentOption
) => {
  const billingTypeValue = billingTerm.type
  const paymentTypeValue = paymentOption.type
  if (billingTypeValue === 'month') {
    if (
      paymentTypeValue === 'month' ||
      (billingTerm?.value === 1 && billingTerm?.type === 'month')
    ) {
      return 'One time'
    }
  } else if (billingTypeValue === 'year') {
    if (paymentTypeValue === 'month') {
      return 'Per month'
    } else if (paymentTypeValue === 'year') {
      if (billingTerm?.value === 1 && paymentOption?.value === 1) {
        return 'One time'
      }
      return 'Per year'
    }
  }
  return ''
}
